// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".satisfactionMessageModal__modal___1OBGJ{display:flex;align-items:center;justify-content:center;text-align:center;flex-direction:column;width:100%}.satisfactionMessageModal__followupQuestion___3oGix{font-size:14px;color:#222;margin-bottom:15px}.satisfactionMessageModal__textArea___2JVA9{height:90px;width:100%;border-color:#e9eff5;border-radius:8px;padding:10px}.satisfactionMessageModal__submitButton___-al18{width:205px;height:33px;margin-top:20px;font-size:16px;box-shadow:0 2px 6px 0 rgba(201,201,201,.5)}.satisfactionMessageModal__doneButton___39E6n{width:205px;height:33px;margin-top:20px;font-size:16px;box-shadow:0 2px 6px 0 rgba(201,201,201,.5)}.satisfactionMessageModal__checkCircleIcon___2YBdd{width:50px;height:50px;color:#00bd67;margin-bottom:15px}.satisfactionMessageModal__followupQuestionContainer___35pO8{padding:20px 20px 0 20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "655px",
	"modal": "satisfactionMessageModal__modal___1OBGJ",
	"followupQuestion": "satisfactionMessageModal__followupQuestion___3oGix",
	"textArea": "satisfactionMessageModal__textArea___2JVA9",
	"submitButton": "satisfactionMessageModal__submitButton___-al18",
	"doneButton": "satisfactionMessageModal__doneButton___39E6n",
	"checkCircleIcon": "satisfactionMessageModal__checkCircleIcon___2YBdd",
	"followupQuestionContainer": "satisfactionMessageModal__followupQuestionContainer___35pO8"
};
export default ___CSS_LOADER_EXPORT___;
